import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { AuthLayout } from '../components';
import { ChooseIntegrationForm } from '../components/ChooseIntegrationForm/ChooseIntegrationForm';
import Homescreen_icon from '../../home/assets/Homescreen.png';
import { getIntegrations, selectIntegration } from '../api';
import {
  AUTH_FORM_CARD_CLASS,
  AUTH_SUBTITLE_CLASS,
  AUTH_TITLE_CLASS,
} from '../lib/authStyles';

export function ChooseIntegrationPage() {
  const navigate = useNavigate();
  const companyId = localStorage.getItem('company_id');

  const {
    data: integrations,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['integrations'],
    queryFn: getIntegrations,
  });

  const { mutate: selectIntegrationMutate, isPending: isSelecting } =
    useMutation({
      mutationFn: selectIntegration,
      onSuccess: (data, { integrationSlug }) => {
        localStorage.setItem('selected_integration_slug', integrationSlug);
        toast.success('Integration selected successfully!');
        navigate(`/${integrationSlug}-setup`);
      },
      onError: (err) => {
        toast.error(
          err?.response?.data?.detail ||
            err?.message ||
            'Failed to select integration. Please try again.',
        );
      },
    });

  const handleBack = () => {
    localStorage.clear();
    window.location.href = '/login';
  };

  const handleSelect = (integrationSlug) => {
    if (!companyId) {
      toast.error('Company ID not found. Please register your company first.');
      navigate('/register');
      return;
    }
    selectIntegrationMutate({ companyId, integrationSlug });
  };

  return (
    <AuthLayout rightImage={Homescreen_icon} rightAlt="Aexon Assistant Mockup">
      <div className="animate-fadeIn">
        <h1 className={AUTH_TITLE_CLASS}>Choose your first integration</h1>
        <h2 className={AUTH_SUBTITLE_CLASS}>
          Connect the tools your team already uses. More integrations are added
          regularly.
        </h2>

        <div className={`${AUTH_FORM_CARD_CLASS} text-left`}>
          <ChooseIntegrationForm
            onSelect={handleSelect}
            integrations={integrations}
            isLoading={isLoading || isSelecting}
            error={error}
          />
          <div className="text-center mt-6">
            <button
              type="button"
              onClick={handleBack}
              className="text-body-lg font-normal font-sf-pro-display text-text-primary hover:text-primary transition-colors cursor-pointer inline-flex items-center gap-1.5"
            >
              <svg
                className="w-4 h-4 inline"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 19.5L8.25 12l7.5-7.5"
                />
              </svg>
              <span>Back to Login</span>
            </button>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
